import React, { useState, useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Overview from '../components/Overview';
import AuthSwitch from '../components/AuthSwitch'

const useStyles = makeStyles(theme => ({
  toolbar: theme.mixins.toolbar
}))

export default function Home() {
  const classes = useStyles();
  return (<div>
    <div className={classes.toolbar} />
        <AuthSwitch redirectTo={'/'}>
          <Overview />
        </AuthSwitch>
    </div>
  );
}